import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

let mainPage = 'dashboard';
const role = localStorage.getItem('role');
if (role == 'contracts') {
  mainPage = 'listoffercontract';
}

const routes: Routes = [
  { path: '', redirectTo: 'pages/' + mainPage, pathMatch: 'full' },
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/app-routing.module.ts